import { render, staticRenderFns } from "./TerraIndigenaStatusDeclarado.vue?vue&type=template&id=188723d1&lang=pug"
import script from "./TerraIndigenaStatusDeclarado.vue?vue&type=script&lang=js"
export * from "./TerraIndigenaStatusDeclarado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports